<template>
  <div>
    <v-dialog
      v-model="show"
      max-width="1200px"
    >
      <v-card>
        <v-card-title>
          Raise Requests History
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-2">
          <v-data-table
            fixed-header
            :headers="headers"
            :items="history"
            :footer-props="{
                'items-per-page-options': [10, 30, 50, -1]
            }"
          >
            <template v-slot:[`item.Approved`]="{ item }">
              <span
                v-if="item.Approved"
                class="success--text darken-2"
              >
                Approved by {{ item.Confirmer }}<br>
              </span>
              <span
                v-if="!item.Approved && item.Reason && !item.Is_Pending"
                class="error--text darken-2"
              >
                Rejected by {{ item.Confirmer }}<br>
                <b>Reason: {{item.Reason}}</b>
              </span>
              <span
                v-if="!item.Approved && item.Is_Pending"
                class="primary--text darken-2"
              >
                Is Pending
              </span>
            </template>
            <template v-slot:[`item.Date_Of_Create`]="{ item }">
              {{ item.Date_Of_Create | dateFilter }}
            </template>
            <template v-slot:[`item.Date_Of_Update`]="{ item }">
              {{ item.Date_Of_Update | dateFilter }}
            </template>
            <template v-slot:[`item.Manage`]="{ item }">
              <v-row>
                <v-col class="mx-0 pr-0">
                  <v-icon color="primary darken-2 white--text" @click="openMessagesDialog(item)">
                    mdi-forum
                  </v-icon>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Messages dialog -->
    <v-dialog
      v-model="messagesDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>Messages</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
          <v-row v-for="(notif, index) in notifications" :key="notif.Notification_ID || index">
            <v-col cols="12" md="8" lg="8">
              <b> {{notif.Creator + ':'}} </b>
              {{ notif.Notification_Message }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- /Messanges dialog -->
  </div>
</template>

<script>
import { getApiErrorMessage } from '@/utils/apiError'
import { formatLocalDate } from '@/utils/dateUtils'
export default {
  name: 'RaiseRequestHistory',
  props: {
    value: {
      required: true,
      default: false
    },
    employeeId: {
      required: false,
      default: null
    }
  },
  data () {
    return {
      history: [],
      notifications: [],
      messagesDialog: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        if (this.value) this.getHistory()
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    headers () {
      return [
        {
          text: 'Created',
          value: 'Date_Of_Create',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Updated',
          value: 'Date_Of_Update',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Creator',
          value: 'Creator',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Confirmer',
          value: 'Confirmer',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Employee',
          value: 'CurrentEmployee',
          width: '5%',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Status',
          value: 'Status_Descr',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Salary',
          value: 'Salary',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Approved',
          value: 'Approved',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Manage',
          value: 'Manage',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: this.employeeId
        }
      ].filter(item => item.show)
    }
  },
  mounted () {
  },
  methods: {
    getHistory () {
      this.axios.get(`/api/requests/raise/${this.employeeId}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.history = res.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    openMessagesDialog (item) {
      this.notifications = item.Notifications
      this.messagesDialog = true
    }
  },
  filters: {
    dateFilter (val) {
      return val ? formatLocalDate(val) : ''
    }
  }
}
</script>
